import _ from 'lodash'
import platformAppComp from './utils/platformAppComp'
import component from '../../component/component'
import dataModel from '../../dataModel/dataModel'
import type {CompRef, Pointer, PS} from '@wix/document-services-types'
import appControllerUtils from '../../appControllerData/appControllerUtils'

const DIMENSIONS = ['width', 'height']

function verifyAppWidgetStructure(serializedComp) {
    if (_.size(serializedComp.components) !== 1) {
        throw new Error('Invalid app widget structure - must have single child')
    }
}

function adjustLayout(serializedComp) {
    const isResponsiveLayout = serializedComp.layouts
    if (isResponsiveLayout) {
        return
    }
    const widgetRootStructure = serializedComp.components[0]
    _.merge(widgetRootStructure, {layout: {x: 0, y: 0}})
    _.forEach(DIMENSIONS, dim => {
        if (_.has(serializedComp, ['layout', dim])) {
            widgetRootStructure.layout[dim] = serializedComp.layout[dim]
        } else if (_.has(widgetRootStructure, ['layout', dim])) {
            _.set(serializedComp, ['layout', dim], widgetRootStructure.layout[dim])
        }
    })
}

function beforeAddHook(ps: PS, compToAddPointer: Pointer, containerPointer: Pointer, serializedComp) {
    verifyAppWidgetStructure(serializedComp)
    adjustLayout(serializedComp)
}

function handleAppWidgetDeletion(ps: PS, widgetRef: Pointer) {
    platformAppComp.removePlatformApplicationFromPageIfLastController(ps, widgetRef)
    platformAppComp.removeControllerFromStateMap(ps, widgetRef)
}

function handleAppWidgetSerialization(ps: PS, controllerRef: Pointer, customStructureData) {
    platformAppComp.addControllerStateToSerializedStructure(ps, controllerRef, customStructureData)
}
function handleAppWidgetParentChange(ps: PS, controllerRef: Pointer, newParentPointer: Pointer) {
    const dataItem = dataModel.getDataItem(ps, controllerRef)
    platformAppComp.removePlatformApplicationFromPageIfLastController(ps, controllerRef)
    platformAppComp.addPlatformAppToPageIfFirstController(
        ps,
        controllerRef,
        appControllerUtils.getControllerAppDefinitionId(dataItem),
        component.getPage(ps, newParentPointer as CompRef)
    )
}

export default {
    beforeAddHook,
    handleAppWidgetDeletion,
    handleAppWidgetSerialization,
    handleAppWidgetParentChange
}
